

import './App.css';
import { Toaster } from 'react-hot-toast';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Componants/Header/header';
import HomeSlider from './Componants/Home/homeslider';
import CategoryPage from './Componants/Cetagory/CetagoryPage';
// import ProductDetail from './Componants/Cetagory/ProductDetail'; // Removed: This was causing the error
import AllProductsPage from './Componants/Cetagory/AllProductPage';
import ComboPage from './Componants/ComboPage';
import BlogPage from './Componants/Blog';
import ComingSoonBanner from './Componants/ComingSoonBanner';
import AboutUs from './Componants/AboutUs';

import Footer from './Componants/Footer/footer';
import WhyAyushvatika from './Componants/WhyAyushvatika';
import CheckoutPage from './Componants/PaymentPage/CheckoutPage';
import { CartProvider } from './Componants/PaymentPage/CartContext';

import CartPage from './Componants/Header/CartPage';
import React, { useState, useEffect } from 'react'
import HerbalCommitment from './Componants/HerbalCommitment';
import HerbalProductsDescriptionSection from './Componants/DescriptionSection';
import ProfilePage from './Pages/ProfilePage'; // Ensure this import path is correct
import { AuthModal } from '../src/Componants/Header/AuthModal'; // Import AuthModal

import ProductViewPage from './Componants/Cetagory/ProductViewPage';

import HairPage from './Componants/HeaderCategoryPages/HairPage';
import LearnAyurvedaPage from './Componants/HeaderCategoryPages/LearnAyurvedaPage';
import DailyRoutinesPage from './Componants/HeaderCategoryPages/DailyRoutinesPage';
import AyurvedicHerbsPage from './Componants/HeaderCategoryPages/AyurvedicHerbs';
import WellnessLifestylePage from './Componants/HeaderCategoryPages/WellnessLifestylePage';
import AyurvedicDietPage from './Componants/HeaderCategoryPages/AyurvedicDietPage ';
import PanchakarmaPage from './Componants/HeaderCategoryPages/PanchakarmaPage';

import AllProductPage from './Componants/Cetagory/AllProductPage';
import TestimonialSlider from './Componants/TestimonialSlider';



//-------------------------Admin------------------------------------------------------
import LoginPage from './Admin/pages/LoginPage';
import SignupPage from './Admin/pages/SignupPage';
import PrivateRoute from './Admin/components/PrivateRoute';
import CategoryListPage from './Admin/pages/CategoryList';
import AddCategoryPage from './Admin/pages/AddCategory';
import EditCategoryPage from './Admin/pages/EditCategoryPage';
import ProductList from './Admin/pages/ProductList';
import CreateProduct from './Admin/pages/CreateProduct';
import EditProduct from './Admin/pages/EditProduct';
import OrderList from './Admin/pages/OrderList';
import PendingOrder from './Admin/pages/PendingOrder';
import CompletedOrder from './Admin/pages/CompletedOrder';
import DeliveryChargePage from './Admin/pages/DeliveryCharge';
import ReturnedOrderList from './Admin/pages/ReturnedOrderList';
import CancelledOrderList from './Admin/pages/CancelledOrderList';
import PlacedOrderList from './Admin/pages/PlacedOrderList';
import SalesReportPage from './Admin/pages/SalesReport';
import HotLeadsPage from './Admin/pages/HotLeads';
import NewLeadPage from './Admin/pages/NewLead';
import SalesPage from './Admin/pages/SalesPage';
import SubordinatesPage from './Admin/pages/SubordinatesPage';
import PendingApprovalsPage from './Admin/pages/PendingApprovalsPage';
import DashboardPage from './Admin/pages/Dashboard';

import SaleOrder from './Admin/pages/SaleOrder';
import UnverifiedOrders from './Admin/pages/UnverifiedOrders';
import VerifiedOrders from './Admin/pages/VerifiedOrders';
import UpdateOrderPage from './Admin/pages/UpdateOrderPage';
import Profile from './Admin/pages/ProfilePage';
import PrivacyPolicy from './Componants/Footer/PrivacyPolicy';
import TermsAndConditions from './Componants/Footer/TermsAndConditions';
import OrderInProcess from './Admin/pages/OrderInProcess';
import ContactPage from './Componants/ContactPage';





// New component to handle scrolling to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// HomeContent component to group all home-specific elements
const HomeContent = () => (
  <>
    <HomeSlider />
    <CategoryPage />
    <ComboPage />

    <HerbalCommitment />
     <WhyAyushvatika />
     <HerbalProductsDescriptionSection />
    <TestimonialSlider />
    
    
    {/* <ComingSoonBanner /> */}
   
    {/* <DeliveryPartners /> */}
  </>
);

const AppContent = () => {
  // Removed unused 'location' variable
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false); // State for AuthModal visibility
  const [user, setUser] = useState<{ id?: string; name: string; email: string; picture?: string; mobile?: string; gender?: string } | null>(null); // User state

  // Check for user in local storage on initial load
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error("Failed to parse user from local storage", e);
        localStorage.removeItem('user'); // Clear corrupted data
      }
    }
  }, []);

  const handleToggleSidebar = (isOpen: boolean) => {
    setIsSidebarOpen(isOpen);
  };

  const handleLoginSuccess = (loggedInUser: any) => {
    // ✅ Login hone par state update karo
    setUser(loggedInUser);
    setShowAuthModal(false); // Modal band karo
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    // Redirect to home or login page if needed, or handle within Header component
    // For now, it just clears user state.
  };

  const handleProfileUpdate = (updatedUser: { id: string; firstName: string; lastName: string; email: string; mobile?: string; profilePictureUrl?: string; gender?: string }) => {
    // Update the user state in AppContent with the new data from ProfilePage
    setUser(prevUser => {
      if (!prevUser) return null;
      return {
        ...prevUser,
        id: updatedUser.id,
        name: `${updatedUser.firstName} ${updatedUser.lastName}`.trim(),
        email: updatedUser.email,
        picture: updatedUser.profilePictureUrl, // <--- ENSURE THIS IS UPDATED
        mobile: updatedUser.mobile,
        gender: updatedUser.gender,
      };
    });
    // Also update localStorage immediately so Header can pick it up on next render/refresh
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    localStorage.setItem('user', JSON.stringify({
      ...storedUser,
      firstName: updatedUser.firstName,
      lastName: updatedUser.lastName,
      email: updatedUser.email,
      mobile: updatedUser.mobile,
      picture: updatedUser.profilePictureUrl, // <--- ENSURE THIS IS UPDATED IN LOCAL STORAGE
      gender: updatedUser.gender,
    }));
  };


  return (
    // Main container now uses flex column to ensure footer sticks to bottom
    <div className="flex flex-col min-h-screen">
      <Toaster position="top-center" reverseOrder={false} />
      {/* Pass user and setShowAuthModal to Header for login/logout functionality */}
      <Header onToggleSidebar={handleToggleSidebar} user={user} setShowAuthModal={setShowAuthModal} onLogout={handleLogout} />

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <main
        className={`flex-grow transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'md:ml-64' : 'md:ml-0'
        } pt-2`} // Added pt-16 to push content below the fixed header (adjust as needed based on header height)
      >
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<HomeContent />} /> {/* Home content now inside Routes */}
          <Route path="/cart" element={<CartPage />} />
           {/* <Route path="/product/:id" element={<ProductDetail />} />  */}
          <Route path="/all-products" element={<AllProductsPage />} />

          <Route path="/checkoutpage" element={<CheckoutPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact-us" element={<ContactPage />} />

           
          

           {/* Heder category Pages */}
           {/* <Route path="/skin" element={<SkinPage />} /> */}
           {/* <Route path="/ayushvatika-product" element={<HairPage />} /> */}
           <Route path="/explore-ayushvatika" element={<LearnAyurvedaPage />} />
           <Route path="/learn-ayurveda/routines" element={<DailyRoutinesPage />} />
           <Route path="/learn-ayurveda/herbs" element={<AyurvedicHerbsPage />} />
            <Route path="/learn-ayurveda/wellness" element={<WellnessLifestylePage />} />
            <Route path="/learn-ayurveda/diet" element={<AyurvedicDietPage />} />
            <Route path="/learn-ayurveda/panchakarma" element={<PanchakarmaPage />} />
           
        
          {/* Pass onLogout and onProfileUpdate to ProfilePage */}
          {/* <Route path="/profile" element={<ProfilePage onLogout={handleLogout} onProfileUpdate={handleProfileUpdate} />} /> */}
          <Route path="/settings" element={<ProfilePage onLogout={handleLogout} onProfileUpdate={handleProfileUpdate} />} />
          <Route path="/make-profit" element={<div>Make Profit Page Content</div>} /> {/* Changed to div as ProfilePage is not relevant here */}
          <Route path="/offers" element={<div>Offers Page Content</div>} />
          <Route path="/faq" element={<div>FAQ Page Content</div>} />
          <Route path="/collection/:collectionPath" element={<div>Collection Page Content</div>} />

          {/* Add the Product Detail Route */}
          <Route path="/product/:id" element={<ProductViewPage />} />
          <Route path="/category/:parentSlug/:childSlug" element={<AllProductPage />} />
            <Route path="/category/:parentSlug" element={<AllProductPage />} />
             <Route path="/category/:categoryId" element={<AllProductPage />} />
             
             <Route path="/privacy" element={<PrivacyPolicy />} />
             <Route path="/term&condition" element={<TermsAndConditions />} />
          {/* <Route path="/products" element={<ProductListingPage />} />
          <Route path="/products/category/:categoryId" element={<ProductListingPage />} /> */}

        </Routes>
      </main>

      <Footer /> {/* Footer is now outside <main> and will be pushed to the bottom */}

      <a
        href="https://wa.me/91XXXXXXXXXX"
        className="fixed bottom-5 right-5 z-10 rounded-full p-2 shadow-lg hover:scale-105 transition"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/Whatsapp.webp" alt="WhatsApp" className="w-14 h-14" />
      </a>

    {/* AuthModal rendered conditionally */}
{showAuthModal && (
  <AuthModal 
      onClose={() => setShowAuthModal(false)} 
      onLoginSuccess={handleLoginSuccess} // <--- Yahan 'onGoogleLogin' ko 'onLoginSuccess' kar dein
  />
)}
    </div>
  );
};



function AdminRoutes() {
  return (
    <Routes>
      
      <Route path="/admin/login" element={<LoginPage />} />
      <Route path="/admin/signup" element={<SignupPage />} />

      <Route element={<PrivateRoute />}>

      
        <Route path="/admin/dashboard" element={<DashboardPage />} />

        {/* Category */}
        <Route path="/admin/category/list" element={<CategoryListPage />} />
        <Route path="/admin/category/add" element={<AddCategoryPage />} />
        <Route path="/admin/category/edit" element={<EditCategoryPage />} />
        <Route path="/admin/category/edit/:id" element={<EditCategoryPage />} />

        {/* Product */}
        <Route path="/admin/product/list" element={<ProductList />} />
        <Route path="/admin/product/add" element={<CreateProduct />} />
        <Route path="/admin/product/edit" element={<EditProduct />} />
        <Route path="/admin/products/edit/:id" element={<EditProduct />} />

        {/* Order */}
        <Route path="/admin/order/details" element={<OrderList />} />
        <Route path="/admin/order/pending" element={<PendingOrder />} />
        <Route path="/admin/order/all" element={<OrderList />} />
        <Route path="/admin/order/completed" element={<CompletedOrder />} />
         <Route path="/admin/order/saleorder" element={<SaleOrder />} />
          <Route path="/admin/order/unverified" element={<UnverifiedOrders />} />
          <Route path="/admin/order/verified" element={<VerifiedOrders />} />
           <Route path="/admin/account/orders-in-process" element={<OrderInProcess />} />

         

        {/* Account */}
        <Route path="/admin/account/delivery-charges" element={<DeliveryChargePage />} />
        <Route path="/admin/account/orders-returned" element={<ReturnedOrderList />} />
        <Route path="/admin/account/orders-cancelled" element={<CancelledOrderList />} />
        <Route path="/admin/account/orders-placed" element={<PlacedOrderList />} />
        <Route path="/admin/account/sales-report" element={<SalesReportPage />} />

        {/* Data */}
        <Route path="/admin/data/hot-data" element={<HotLeadsPage />} />
        <Route path="/admin/data/new-data" element={<NewLeadPage />} />
        <Route path="/admin/leads/sales/:id" element={<SalesPage />} />
        <Route path="/admin/data/all-order" element={<OrderList />} />
          <Route path="/admin/update-order/:orderId" element={<UpdateOrderPage />} />

        {/* Subordinates */}
        <Route path="/admin/subordinates/manage" element={<SubordinatesPage />} />
        <Route path="/admin/profile/:id" element={<Profile />} />
        <Route path="/admin/subordinates/pending-approvals" element={<PendingApprovalsPage />} />
      </Route>
    </Routes>
  );
}

function MainRoutes() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return <>{isAdminRoute ? <AdminRoutes /> : <AppContent />}</>;
}

function App() {
  return (
    <Router>
      <CartProvider>
       <MainRoutes />
      </CartProvider>
    </Router>
  );
}

export default App;